export const WORDING = {
  GENERAL_DELETE_TITLE: 'Are you sure?',
  GENERAL_DELETE_MESSAGE: "You can't undo this action afterwards.",
  GENERAL_CONFIRM_DELETE: 'Delete',
  GENERAL_CANCEL: 'Cancel',
  GENERAL_SUCCESS: 'Success',
  GENERAL_ERROR: 'Something went wrong. Please try again.',
  UPDATE_BUSINESS_INFO_SUCCESS: 'Business information updated successfully.',
  UPDATE_BUSINESS_INFO_FAILED:
    'Failed to update business information. Please try again.',
  CREATE_SERVICE_SUCCESS: 'Service added successfully',
  CREATE_SERVICE_FAILED: 'Failed to add service. Please try again.',
  UPDATE_SERVICE_SUCCESS: 'Service updated successfully',
  UPDATE_SERVICE_FAILED: 'Failed to update service. Please try again.',
  DELETE_SERVICE_SUCCESS: 'Service deleted successfully',
  DELETE_SERVICE_FAILED: 'Failed to delete service. Please try again.',
  UPDATE_USER_PROFILE_INFO_SUCCESS:
    'User profile information updated successfully.',
  UPDATE_USER_PROFILE_INFO_FAILED:
    'Failed to update User profile information. Please try again.',
  APPROVE_BUSINESS_SUCCESS: 'Business approved successfully',
  APPROVE_BUSINESS_FAILED: 'Failed to approve business. Please try again.',
};
